import { BodyLong, Heading, Link, VerticalSpace } from '@elhub/ds-components'

import React from 'react'

const Meta = () => {
  return (
    <>
      <Heading>Meta</Heading>
      <BodyLong size='small'>
        Metadata of the datasets under each of the entities like price-areas, municipalities, etc. The
        datasets are of consumption or production data. They are aggregated on the respective entities (e.g.
        price area or municipality) and on a time interval (e.g. hourly).
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        Datasets can be accessed through the entities' respective endpoints using the "dataset" parameter.
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        For example consumption for the price-areas entity:{' '}
        <Link
          variant='primary'
          href='https://api.elhub.no/energy-data/v0//price-areas?dataset=consumption_per_group_mba_hour'
        >
          https://api.elhub.no/energy-data/v0//price-areas?dataset=consumption_per_group_mba_hour
        </Link>
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        For now, only details of /price-areas and /municipalities entities can be queried with the /meta
        endpoint.
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <Link variant='primary' href='https://api.elhub.no/energy-data/v0/meta/price-areas'>
          https://api.elhub.no/energy-data/v0/meta/price-areas
        </Link>
      </BodyLong>
    </>
  )
}

export default Meta
